<app-component-header></app-component-header>

<p-blockUI [blocked]="blocked">
    <div id="center">
        <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
    </div>
</p-blockUI>

<div #mainDiv name="main-component-div" class="m-2">
    <div class="col-12 mt-2 flex">
        <div class="col-5">
            <div class="flex mb-1">
                <button pButton class="w-4 h-2rem action-button" type="button" label="Storage Location"></button>
                <p-dropdown class="h-2rem w-4 inline-flex" [options]="storageLocationList" filter="true"
                    [(ngModel)]="selectedStorageLocation" optionLabel="storageName" optionValue="storageName"
                    placeholder="Storage Location">
                </p-dropdown>
            </div>
        </div>
    </div>
    <div class="col-12 flex">
        <div class="col-5">
            <div class="inputgroup">
                <button pButton class="w-4 h-2rem action-button" label="Plate-ID"></button>
                <input pInputText id="plate-id-input" class="h-2rem w-4 mr-2" placeholder="Scan Plate-ID"
                    [(ngModel)]="enteredPlateID" size="10" (keydown.enter)="searchForPlate()" />
                <button pButton class="start-button w-3 h-2rem" type="button" label="Search"
                    (click)=searchActiveStorages()></button>
            </div>
        </div>
        <div class="col-7 flex justify-content-center">
            <div class="col-3 p-0">
                <button pButton class="start-button w-10 h-2rem" typselectedStorageLocatione="button" label="Store"
                    (click)=addPlateToStorage()></button>
            </div>
            <div class="col-3 p-0">
                <button pButton class="complete-button w-10 h-2rem" type="button" label="Remove"
                    (click)=restorePlateFromStorage()></button>
            </div>
        </div>
    </div>

    <div class="m-3">
        <p-table [columns]="listOfStorageLocationsPositiveSamples" [loading]="loading" [value]="storageList"
            [totalRecords]="totalStorages" [paginator]="true" [rows]="10" [lazy]="true"
            (onLazyLoad)="fetchStorageDetails($event)" #storageTable>
            <ng-template pTemplate="caption">
                List of Storage Locations
            </ng-template>
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th *ngFor="let col of columns" id="{{col.header}}">
                        {{col.header}}
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                <tr [pSelectableRow]="rowData">
                    <ng-container *ngFor="let col of columns">
                        <td *ngIf="col.field === 'plateCount'">
                            {{rowData.plateIDs.length}}
                        </td>
                        <td *ngIf="col.field !== 'action' && col.field !== 'active' && col.field !== 'plateCount'">
                            {{rowData[col.field]}}
                        </td>
                        <td *ngIf="col.field === 'action'">
                            <button pButton class="w-2 h-2rem m-1 start-button" type="button" label="Show"
                                (click)="showPlates(rowIndex)"></button>
                            <button pButton class="w-2 h-2rem m-1 action-button" type="button" label="Edit"
                                (click)="editStorage(rowIndex)"></button>
                            <button pButton class="w-3 h-2rem m-1 complete-button" type="button" label="Description"
                                (click)="showDescription(rowIndex)"></button>
                        </td>
                        <td *ngIf="col.field === 'active'">
                            <p-checkbox id="active" [disabled]="true" [(ngModel)]="rowData[col.field]" binary="true">
                            </p-checkbox>
                        </td>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                Showing {{state.totalRecords>0 ? state.first + 1 : 0 }} to
                {{ state.totalRecords > 0 ? (((state.first + state.rows) > state.totalRecords) ?
                (state.first+(state.totalRecords%state.rows)) : (state.first+state.rows)) : 0 }}
                of {{state.totalRecords}}
            </ng-template>
            <ng-template pTemplate="paginatorright" let-state>
                <p-checkbox label="Show Active Storages" binary="true" [(ngModel)]="showActiveStorages"
                    (onChange)="storageTable.reset()"></p-checkbox>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length">
                    No records found
                  </td>
                </tr>
              </ng-template>
        </p-table>
    </div>

    <div class="text-center">
        <button type="button" class="ml-1 h-2rem" pButton icon="fa fa-plus" (click)="showDialogToAddStorage()"
            label="Add Storage"></button>
    </div>
</div>

<p-dialog [(header)]="storeHeader" class="bg-primary button-dialog" [(visible)]="displayStoreDialog" showEffect="fade"
    [modal]="true" position="top" [style]="{'width':'25%'}" (onHide)="closeDialogs('store')">
    <div class="col-12 flex">
        <table>
            <caption class="sr-only">Table for Store plates.</caption>
            <thead>
                <tr class="border-none">
                    <th class="border-none"></th>
                </tr>
            </thead>
            <tbody>
                <tr class="border-none">
                    <div class="mt-3 mb-3">
                        <span class="font-bold">Scan Plates for storage</span>
                    </div>
                </tr>
                <tr class="border-none">
                    <div class="w-full flex mb-1">
                        <button pButton class="theme-button w-6 h-2rem" type="button" label="Storage Location"></button>
                        <p-dropdown class="h-2rem w-6 inline-flex" [options]="storageLocationList" filter="true"
                            (onChange)="onSelectedOptionChanged($event)" [(ngModel)]="selectedStorageLocation"
                            optionLabel="storageName" optionValue="storageName" placeholder="Storage Location">
                        </p-dropdown>
                    </div>
                </tr>
                <tr class="border-none">
                    <input pInputText name="plateId" class="h-2rem mt-2" [(ngModel)]="enteredStorePlateID"
                        id="store-plate-id" (keydown.enter)="checkIfPlateExists('multiple',enteredStorePlateID)"
                        placeholder="Scan Plates" />
                </tr>
                <tr *ngFor="let plate of multiStorePlateList; let i = index;">
                    <input pInputText name="plateId" class="h-2rem" [value]="plate?.plateId" id="plateid" readonly />
                    <button pButton icon="fa fa-times-circle" class="complete-button h-2rem" style="width: 10%;"
                        (click)="removePlateFromStoreList(i)"></button>
                </tr>
                <tr class="col-12 mt-2 mb-2 d-flex justify-content-center border-none">
                    <button class="w-6 h-2rem start-button" [disabled]="disableStoreButton" pButton label="Store"
                        (click)="addMultiPlateToStorage()"></button>
                </tr>
            </tbody>
        </table>
    </div>
</p-dialog>

<p-dialog [(header)]="restoreHeader" class="bg-primary button-dialog" [(visible)]="displayRestoreDialog"
    showEffect="fade" [modal]="true" position="top" (onHide)="closeDialogs('restore')">
    <div class="col-12 flex">
        <table>
            <caption class="sr-only">Table for Remove plates.</caption>
            <thead>
                <tr class="border-none">
                    <th class="border-none"></th>
                </tr>
            </thead>
            <tbody>
                <tr class="border-none">
                    <div class="mt-3 mb-3">
                        <span class="font-bold">Scan Plates for restoration</span>
                    </div>
                </tr>
                <tr class="border-none">
                    <input pInputText name="plateId" class="h-2rem" [(ngModel)]="enteredRestorePlateID"
                        id="restore-plate-id" (keydown.enter)="checkPlateInStorage()" placeholder="Scan Plates" />
                </tr>
                <tr *ngFor="let plate of multiRestorePlateList; let i = index;" class="border-none">
                    <input pInputText name="plateId" class="h-2rem" [value]="plate" id="plateid" readonly />
                    <button pButton icon="fa fa-times-circle" class="complete-button h-2rem" style="width: 10%;"
                        (click)="removePlateFromRestoreList(i)"></button>
                </tr>
                <tr class="mt-2 mb-2 col-12 d-flex justify-content-center border-none">
                    <button pButton class="complete-button h-2rem w-6" label="Remove"
                        (click)="removeMultiplePlatesFromStorage()"></button>
                </tr>
            </tbody>
        </table>
    </div>
</p-dialog>

<p-dialog [(header)]="storedPlatesHeader" class="bg-primary button-dialog" [(visible)]="displayPlatesDialog"
    showEffect="fade" [modal]="true" [style]="{'width':'25%'}" position="top">
    <div class="col-12" *ngIf="selectedStorage.plateIDs && selectedStorage.plateIDs.length != 0">
        <ul>
            <li *ngFor="let plate of selectedStorage.plateIDs">
                <span *ngIf="plate == enteredPlateID" style="background-color: yellow;">{{plate}}</span>
                <span *ngIf="plate != enteredPlateID">{{plate}}</span>
            </li>
        </ul>
    </div>
    <div class="col-12" *ngIf="selectedStorage.plateIDs && selectedStorage.plateIDs.length == 0">
        <span>No Plates Stored</span>
    </div>
</p-dialog>

<p-dialog header="Create Storage Location" class="bg-primary button-dialog" [(visible)]="displayDialog"
    showEffect="fade" [modal]="true" position="top" (onHide)="clearValues()">
    <div>
        <div class="col-12 flex">
            <div class="col-4 h-2rem">
                <label>Storage Name: </label>
            </div>
            <div class="col-8">
                <input pInputText type="text" class="h-2rem w-full" [disabled]="storageEdit" id="form-storage-name"
                    placeholder="Enter Storage Name" [(ngModel)]="storageName">
            </div>
        </div>

        <div class="col-12 flex">
            <div class="col-4"> Process Step: </div>
            <div class="col-8">
                <p-dropdown [options]="processStepOptions" placeholder="Select Process Step" filter="true"
                    optionLabel="name" [(ngModel)]="processStep">
                </p-dropdown>
            </div>
        </div>

        <div class="col-12 flex">
            <div class="col-4">
                <label>Description: </label>
            </div>
            <div class="col-8">
                <textarea type="text" class="w-full" name="log" rows="3" cols="35" id="form-description"
                    placeholder="Enter Description" [(ngModel)]="description">
        </textarea>
            </div>
        </div>

        <div class="text-center">
            <p-checkbox label="Active Location" binary="true" [(ngModel)]="active"></p-checkbox>
        </div>

    </div>
    <div class="text-center">
        <button *ngIf="!storageEdit" type="button" (click)="addStorage()"
            class="start-button text-white w-4 mt-4 mr-6 h-2rem"> Create </button>
        <button *ngIf="storageEdit" type="button" (click)="updateStorage()"
            class="start-button text-white w-4 mt-4 h-2rem"> Update </button>
        <button *ngIf="!storageEdit" type="button" (click)="clearValues()"
            class="complete-button text-white w-4 mt-4 h-2rem"> Clear </button>
    </div>
</p-dialog>

<p-dialog [(header)]="descriptionHeader" class="bg-primary button-dialog" [(visible)]="displayDescriptionDialog"
    showEffect="fade" [modal]="true" position="top">
    <div class="col-12 flex">
        {{selectedStorage.description}}
    </div>
</p-dialog>